if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.onKeydown = this.onKeydown.bind(this);
      }

      hide() {
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        this.removeEventListener('keydown', this.onKeydown);
        super.hide();

        // Restore the exact gallery media that opened the modal.
        // This is deliberately independent of the modal's active classes.
        window.requestAnimationFrame(() => {
          document.querySelectorAll('.imm-product-gallery media-gallery').forEach((gallery) => {
            const items = Array.from(gallery.querySelectorAll('.product__media-item[data-media-id]'));
            const activeItem = items.find((item) => {
              const galleryMediaId = item.dataset.mediaId || '';
              return galleryMediaId === mediaId || galleryMediaId.endsWith(`-${mediaId}`);
            });

            if (!activeItem) return;

            items.forEach((item) => item.classList.toggle('is-active', item === activeItem));

            gallery.querySelectorAll('.thumbnail').forEach((thumbnail) => {
              thumbnail.removeAttribute('aria-current');
            });

            gallery
              .querySelector(`[data-target="${activeItem.dataset.mediaId}"] .thumbnail`)
              ?.setAttribute('aria-current', 'true');

            const track = gallery.querySelector('.product__media-list');
            if (track) {
              window.requestAnimationFrame(() => {
                track.scrollTo({ left: activeItem.offsetLeft, top: 0, behavior: 'auto' });
              });
            }
          });
        });
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.addEventListener('keydown', this.onKeydown);
      }

      onKeydown(event) {
        if (event.key === 'ArrowLeft') this.showSiblingMedia(-1);
        if (event.key === 'ArrowRight') this.showSiblingMedia(1);
      }

      showSiblingMedia(direction) {
        const media = Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
        const currentIndex = media.findIndex((item) => item.classList.contains('active'));
        if (currentIndex < 0 || media.length < 2) return;
        const nextIndex = (currentIndex + direction + media.length) % media.length;
        this.activateMedia(media[nextIndex]);
      }

      showActiveMedia() {
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        const activeMedia =
          this.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.querySelector('.product-media-modal__content > [data-media-id]');
        if (!activeMedia) return;
        this.activateMedia(activeMedia);
      }

      activateMedia(activeMedia) {
        this.querySelectorAll('.product-media-modal__content > [data-media-id]').forEach((element) => {
          element.classList.toggle('active', element === activeMedia);
          element.setAttribute('aria-hidden', element === activeMedia ? 'false' : 'true');
        });

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        const container = this.querySelector('[role="document"]');
        if (container) {
          container.scrollTop = 0;
          container.scrollLeft = 0;
        }

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    },
  );
}
